import TaskListTable from '@/pages/gateway/task-list/task-list-main'
const TaskList: React.FC = () => <TaskListTable />
export default TaskList
